import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { operations } from './generated/gcss';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { apiGcssFetcher } from '../fetcher';
import { GCSS_URLS } from '@/constants/api';
import { sleep } from '@/utils/promise';
export type MerchantsListResponse = operations['merchants']['responses']['200']['content']['application/json'] | undefined;
type MerchantsRequest = operations['merchants']['parameters']['query'];
export function useMerchants(params) {
  const $ = _c(7);
  let t0;
  if ($[0] !== params) {
    t0 = QUERY_KEYS.gcssMerchants(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = async t2 => {
      const {
        signal
      } = t2;
      await sleep(400);
      if (!signal?.aborted) {
        const res = await apiGcssFetcher(GCSS_URLS.merchantsList, {
          searchParams: params
        });
        const results = await res.json;
        return (results || []).map(_temp);
      }
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      placeholderData: keepPreviousData
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
}
function _temp(merchant) {
  return {
    label: merchant.name,
    value: merchant.name
  };
}